
<template>
    <div>
        <div class="row align-items-center">

            <div class="col-lg-12">
                <base-input alternative=""
                    label="Parameter's Title"
                    input-classes="form-control-alternative"
                    v-model="record.title"
                    required
                />
            </div>

            <div class="col-lg-12">
                <base-input alternative=""
                    label="Parameter's Content">
                    <ckeditor
                        :editor="editor"
                        v-model="record.content"
                        :config="editorConfig"
                    ></ckeditor>
                </base-input>
            </div>

            <div
                class="col-sm-12 text-center"
                v-if='showErrorStatus'
            >
                <base-alert :type="errorType">
                    <span class="alert-inner--icon"><i class="ni ni-like-2"></i></span>
                    <span class="alert-inner--text">
                        {{errorMsg}}
                    </span>
                </base-alert>
            </div>

            <hr class="my-4" />

            <div class="col-lg-12">
                <base-button
                    type="success" size="lg"
                    @click="updateParameterRecord()"
                    :disabled="(privileges && privileges.update == 'no') || ! privileges"
                >
                    <i class="fa fa-save"></i>
                    {{isloading ? 'Please Wait...' : 'Update Parameter'}}
                </base-button>

                <base-button
                    type="danger" size="lg"
                    class="right"
                    @click="$emit('showEditPage', false)"
                >
                    <i class="fa fa-times"></i>
                    Cancel
                </base-button>
            </div>
        </div>

    </div>
</template>
<script>
    import { mapActions } from 'vuex';
    import swal from 'sweetalert2';// import sweet alert
    import ClassicEditor from '@ckeditor/ckeditor5-build-classic';
    import CKEditor from '@ckeditor/ckeditor5-vue';

    export default {
        name: 'EditParameter',
        props: ['privileges', 'parameter', 'loadSiteParameters', 'showEditPage'],
        components: {
            ckeditor: CKEditor.component
        },
        data() {
            return {
                record: {
                    title: null,
                    content: null,
                    id: null,
                    admin_id: null
                },
                editor: ClassicEditor,
                editorConfig: {
                    toolbar: [ 'heading', '|', 'bold', 'italic', 'bulletedList', 'numberedList' ],
                },
                showErrorStatus: false,
                errorType: null,
                errorMsg: null,
                isloading: false
            }
        },
        methods: {
            ...mapActions(['updateSiteParameter']),
            setData() {// set data for editing
                this.emptyRecords();
                let parameter = this.parameter;
                if(parameter) {
                    this.record.title = parameter.title;
                    this.record.content = parameter.content;
                    this.record.id = parameter.id;
                }
            },
            emptyRecords() {
                this.record.title = null;
                this.record.content = null;
                this.record.id = null;
            },
            updateParameterRecord() {
                let status = this.validatedInputs();// validate inputs
                if(status) {// save department
                    let data = this.record;
                    data.admin_id = this.$store.state.user.userId;// add admin user id
                    this.preloader(); // show loading
                    this.updateSiteParameter(data).then((res) => {// update email
                        if(res.status) {
                            this.showEditPage(false);// hide edit page
                            this.loadSiteParameters();// refresh page
                            swal.fire("Parameter Updated", res.msg, "success");
                        } else {
                            this.loadSiteParameters();// refresh page
                            swal.fire("Error Occurred!", res.msg, "warning");
                        }
                    }).
                    catch(err => {
                        this.loadSiteParameters();// refresh page
                        swal.fire(err.message+"!", "An error occurred while saving, try again", "warning");
                    });
                }
            },
            validatedInputs() {
                let data = this.record;
                let parameter = { title: null, content: null };
                parameter.content = data.content == null || data.content == '' ?
                                    this.showInuptError('Content') : data.content;
                parameter.title = data.title == null || data.title == '' ?
                                    this.showInuptError('Title') : data.title;
                return this.isEmpty(parameter) ? true : false;
            },
            isEmpty(obj) {// check for empty field
                return ! Object.keys(obj).some(k => !obj[k]);
            },
            showInuptError(name) {
                this.isloading = false;
                this.showErrorStatus = true
                this.errorType = 'warning'
                this.errorMsg = 'Invalid ' + name + ' has been entered';
                var self = this;
                setTimeout(function() { self.showErrorStatus = false; }, 5000);
            },
            preloader() {
                return  swal.fire({
                    title: 'Please Wait...',
                    html: 'Trying to fetch data from <b>server</b>',
                    // timer: 2000,
                    timerProgressBar: true,
                    onBeforeOpen: () => {
                        swal.showLoading()
                    },
                });
            }
        },
        created() {// set records
            this.setData();
        }
    };
</script>
<style scoped>
    .right {
        float: right;
    }
</style>
<style>
    .ck-content {
        height: 500px;
    }
</style>